import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadCompletePriceAtom = createMutationAtomFactory(
  'trade.purchaseLoadCompletePrice',
  (params: { id: string }) => ({
    tradePurchaseLoadCompletePrice: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
